import { __decorate, __extends } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import IosSdk from '@/components/PrivacyProlicy/IosSdk.vue';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //  2024-09-25 10:23:22：过滤指定马甲包主体地址显示
        _this.filterList = ['chutian', 'youyu_chutian', 'xiangyu_chuai', 'chuai'];
        return _this;
    }
    //@ 2021/12/29 15:42 跳转页面
    View.prototype.toPage = function (url) {
        this.$emit('toPage', url);
    };
    View = __decorate([
        Options({
            components: { IosSdk: IosSdk },
            props: {},
            emits: ['toPage'],
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
